export const resetSetValueObject = (valueMap) => {
  const setValueObject = [];

  for (const key in valueMap) {
    if (valueMap.hasOwnProperty(key)) {
      const target = {
        name: key,
        value: ''
      };
      setValueObject.push({ target });
    }
  }

  return setValueObject;


}


/**
 * Turns a picked record into the `[{ target: { name, value } }]` payload the form
 * setters expect, copying source fields into form fields via `valueMap`.
 *
 * A field whose source value is null is normally omitted, so it keeps whatever
 * it already held. That is right for fields the record simply does not carry,
 * and wrong for fields where null is the answer — pick a payment term with no
 * schedule after one that had a schedule, and `paymentSchedule` would keep the
 * stale `true` because nothing was written.
 *
 * `nullDefaults` names the fields where null is meaningful and says what to
 * write instead. Only names present in the map are emitted; everything else
 * keeps the old skip-and-preserve behaviour.
 */
function generateSetValueObject(data, valueMap, nullDefaults = {}) {
  const setValueObject = [];

  for (const key in valueMap) {
    if (!Object.prototype.hasOwnProperty.call(valueMap, key)) continue;

    const value = data[valueMap[key]] ?? null;

    if (value !== null) {
      setValueObject.push({ target: { name: key, value } });
    } else if (Object.prototype.hasOwnProperty.call(nullDefaults, key)) {
      setValueObject.push({ target: { name: key, value: nullDefaults[key] } });
    }
  }

  return setValueObject;
}

export default generateSetValueObject


